import configServices from './services';
import orderBy from 'lodash/orderBy';
import {
    call,
    put,
    select,
    takeEvery
} from 'redux-saga/effects';
import {
    configActions,
    parseConfig,
    parseNotification
} from '.';

function* _createNotification ({ payload }) {
    try {
        yield put(configActions.setConfigNotificationsLoading(true));
        const { data } = yield call(configServices.postNotification, null, payload);
        const { config: { notifications } } = yield select();
        yield put(configActions.setConfigNotifications(orderBy([...notifications, parseNotification(data)], ['type'])));
    } catch (e) {

    } finally {
        yield put(configActions.setConfigNotificationsLoading(false));
    }
}

function* _createTemplate ({ payload }) {
    try {
        yield put(configActions.setConfigTemplatesLoading(true));
        const { data } = yield call(configServices.postTemplate, null, payload);
        const { config: { templates } } = yield select();
        yield put(configActions.setConfigTemplates(orderBy([...templates, data], ['name'])));
    } catch (e) {

    } finally {
        yield put(configActions.setConfigTemplatesLoading(false));
    }
}

function* _deleteChatbotFeature ({ payload }) {
    try {
        const { config: { chatbotFeatureList } } = yield select();
        yield put(configActions.setConfigChatbotFeatureList(chatbotFeatureList.filter(feature => feature !== payload)));
        yield call(configServices.deleteChatbotFeature, { feature: payload });
    } catch (e) {
        
    }
}

function* _deleteChatbotNode ({ payload }) {
    try {
        const { config: { featureConfiguration } } = yield select();
        yield put(configActions.setConfigFeatureConfigurationProcessing(true));
        yield call(configServices.deleteChatbotNode, { id: payload });
        yield put(configActions.setConfigFeatureConfiguration(featureConfiguration.filter(({ id }) => id !== payload)));
    } catch (e) {
        
    } finally {
        yield put(configActions.setConfigFeatureConfigurationProcessing(false));
    }
}

function* _deleteNotification ({ payload }) {
    try {
        yield put(configActions.setConfigNotificationsLoading(true));
        yield call(configServices.deleteNotification, { id: payload });
        const { config: { notifications } } = yield select();
        yield put(configActions.setConfigNotifications(notifications.filter(({ id }) => id !== payload)));
    } catch (e) {

    } finally {
        yield put(configActions.setConfigNotificationsLoading(false));
    }
}

function* _deleteTemplate ({ payload }) {
    try {
        yield put(configActions.setConfigTemplatesLoading(true));
        yield call(configServices.deleteTemplate, { id: payload });
        const { config: { templates } } = yield select();
        yield put(configActions.setConfigTemplates(templates.filter(({ id }) => id !== payload)));
    } catch (e) {

    } finally {
        yield put(configActions.setConfigTemplatesLoading(false));
    }
}

function* _getBackendConfiguration () {
    try {
        yield put(configActions.setConfigPlatformConfigurationLoading(true));
        const { data } = yield call(configServices.fetchBackendConfiguration);
        yield put(configActions.setConfigBackendConfiguration(data));
    } catch (e) {
        
    } finally {
        yield put(configActions.setConfigPlatformConfigurationLoading(false));
    }
}

function* _getChatbotFeatureList () {
    try {
        yield put(configActions.setConfigChatbotFeatureListLoading(true));
        const { data } = yield call(configServices.fetchChatbotFeatureList);
        yield put(configActions.setConfigChatbotFeatureList(data));
    } catch (e) {

    } finally {
        yield put(configActions.setConfigChatbotFeatureListLoading(false));
    }
}

function* _getChatbotJSON ({ payload }) {
    try {
        yield put(configActions.setConfigChatbotJSONLoading(true));
        const { data } = yield call(configServices.fetchChatbotJSON, null, { feature: payload });
        yield put(configActions.setConfigChatbotJSON(data));
    } catch (e) {
        yield put(configActions.setConfigChatbotJSON(''));
    } finally {
        yield put(configActions.setConfigChatbotJSONLoading(false));
    }
}

function* _getConfig () {
    try {
        yield put(configActions.setConfigLoaded(false));
        const { data } = yield call(configServices.fetchConfig);
        yield put(configActions.setConfigConfigurations(parseConfig(data)));
        yield put(configActions.setConfigLoaded(true));
    } catch (e) {
        yield put(configActions.setConfigError(true));
    }
}

function* _getConfigNotificationTypes () {
    try {
        yield put(configActions.setConfigNotificationTypesLoading(true));
        const { data } = yield call(configServices.fetchConfigNotificationTypes);
        yield put(configActions.setConfigNotificationTypes(data.map(value => ({ label: value, value }))));
    } catch (e) {
        
    } finally {
        yield put(configActions.setConfigNotificationTypesLoading(false));
    }
}

function* _getConfigNotifications () {
    try {
        yield put(configActions.setConfigNotificationsLoading(true));
        const { data } = yield call(configServices.fetchConfigNotifications);
        yield put(configActions.setConfigNotifications(data.map(item => parseNotification(item))));
    } catch (e) {
        
    } finally {
        yield put(configActions.setConfigNotificationsLoading(false));
    }
}

function* _getConfigTemplates () {
    try {
        yield put(configActions.setConfigTemplatesLoading(true));
        const { data } = yield call(configServices.fetchConfigTemplates);
        yield put(configActions.setConfigTemplates(data));
    } catch (e) {
        
    } finally {
        yield put(configActions.setConfigTemplatesLoading(false));
    }
}

function* _getCronConfiguration () {
    try {
        yield put(configActions.setConfigPlatformConfigurationLoading(true));
        const { data } = yield call(configServices.fetchCronConfiguration);
        yield put(configActions.setConfigCronConfiguration(data));
    } catch (e) {
        
    } finally {
        yield put(configActions.setConfigPlatformConfigurationLoading(false));
    }
}

function* _getFeatureConfiguration ({ payload }) {
    try {
        yield put(configActions.setConfigFeatureConfigurationLoading(true));
        const { data } = yield call(configServices.fetchFeatureConfiguration, { feature: payload });
        yield put(configActions.setConfigFeatureConfiguration(data));
    } catch (e) {
        
    } finally {
        yield put(configActions.setConfigFeatureConfigurationLoading(false));
    }
}

function* _getServicesConfiguration () {
    try {
        yield put(configActions.setConfigPlatformConfigurationLoading(true));
        const { data } = yield call(configServices.fetchServicesConfiguration);
        const parsedServices = data.map(s => ({
            ...s,
            label: `${ s?.controller }:${ s?.method }`
        }));
        yield put(configActions.setConfigServicesConfiguration(parsedServices));
    } catch (e) {
        
    } finally {
        yield put(configActions.setConfigPlatformConfigurationLoading(false));
    }
}

function* _updateBackendConfiguration ({ payload }) {
    try {
        yield put(configActions.setConfigPlatformConfigurationProcessing(true));
        yield call(configServices.putBackendConfiguration, null, payload);
    } catch (e) {

    } finally {
        yield put(configActions.setConfigPlatformConfigurationProcessing(false));
    }
}

function* _updateChatbotFeature ({ payload }) {
    try {
        yield put(configActions.setConfigChatbotJSONLoading(true));
        yield call(configServices.putChatbotFeature, null, payload);
    } catch (e) {

    } finally {
        yield put(configActions.setConfigChatbotJSONLoading(false));
    }
}

function* _updateCronConfiguration ({ payload }) {
    try {
        yield put(configActions.setConfigPlatformConfigurationProcessing(true));
        yield call(configServices.putCronConfiguration, null, payload);
    } catch (e) {

    } finally {
        yield put(configActions.setConfigPlatformConfigurationProcessing(false));
    }
}

function* _updateFeatureSchema ({ payload }) {
    try {
        yield put(configActions.setConfigFeatureConfigurationLoading(true));
        const { data } = yield call(configServices.putFeatureSchema, null, payload);
        yield put(configActions.setConfigFeatureConfiguration(data));
    } catch (e) {

    } finally {
        yield put(configActions.setConfigFeatureConfigurationLoading(false));
    }
}

function* _upsertChatbotNode ({ payload }) {
    try {
        const { config: { featureConfiguration } } = yield select();
        yield put(configActions.setConfigFeatureConfigurationProcessing(true));
        const { id } = payload;
        const { data } = !id
            ? yield call(configServices.postChatbotNode, null, payload)
            : yield call(configServices.putChatbotNode, { id }, payload);
        if (id) {
            yield put(configActions.setConfigFeatureConfiguration([
                ...featureConfiguration.filter(({ id }) => id !== payload.id),
                data
            ]));
        } else {
            yield put(configActions.setConfigFeatureConfiguration([...featureConfiguration, data]));
        }
    } catch (e) {
        
    } finally {
        yield put(configActions.setConfigFeatureConfigurationProcessing(false));
    }
}

function* _updateNotification ({ payload: { id, ...body } }) {
    try {
        yield put(configActions.setConfigNotificationsLoading(true));
        const { data } = yield call(configServices.putNotification, { id }, body);
        const { config: { notifications } } = yield select();
        const newNotifications = [...notifications];
        newNotifications[notifications.findIndex(({ id: itemId }) => itemId === id)] = parseNotification(data);
        yield put(configActions.setConfigNotifications(orderBy(newNotifications, ['type'])));
    } catch (e) {

    } finally {
        yield put(configActions.setConfigNotificationsLoading(false));
    }
}

function* _updateServicesConfiguration ({ payload }) {
    try {
        yield put(configActions.setConfigPlatformConfigurationProcessing(true));
        yield call(configServices.putServicesConfiguration, null, payload);
    } catch (e) {

    } finally {
        yield put(configActions.setConfigPlatformConfigurationProcessing(false));
    }
}

function* _updateTemplate ({ payload: { id, ...body } }) {
    try {
        yield put(configActions.setConfigTemplatesLoading(true));
        const { data } = yield call(configServices.putTemplate, { id }, body);
        const { config: { templates } } = yield select();
        const newTemplates = [...templates];
        newTemplates[templates.findIndex(({ id: itemId }) => itemId === id)] = data;
        yield put(configActions.setConfigTemplates(orderBy(newTemplates, ['name'])));
    } catch (e) {

    } finally {
        yield put(configActions.setConfigTemplatesLoading(false));
    }
}

export default [
    takeEvery(configActions.createNotification.type, _createNotification),
    takeEvery(configActions.createTemplate.type, _createTemplate),
    takeEvery(configActions.deleteChatbotFeature.type, _deleteChatbotFeature),
    takeEvery(configActions.deleteChatbotNode.type, _deleteChatbotNode),
    takeEvery(configActions.deleteNotification.type, _deleteNotification),
    takeEvery(configActions.deleteTemplate.type, _deleteTemplate),
    takeEvery(configActions.getBackendConfiguration.type, _getBackendConfiguration),
    takeEvery(configActions.getChatbotFeatureList.type, _getChatbotFeatureList),
    takeEvery(configActions.getChatbotJSON.type, _getChatbotJSON),
    takeEvery(configActions.getConfig.type, _getConfig),
    takeEvery(configActions.getConfigNotifications.type, _getConfigNotifications),
    takeEvery(configActions.getConfigNotificationTypes.type, _getConfigNotificationTypes),
    takeEvery(configActions.getConfigTemplates.type, _getConfigTemplates),
    takeEvery(configActions.getCronConfiguration.type, _getCronConfiguration),
    takeEvery(configActions.getFeatureConfiguration.type, _getFeatureConfiguration),
    takeEvery(configActions.getServicesConfiguration.type, _getServicesConfiguration),
    takeEvery(configActions.updateBackendConfiguration.type, _updateBackendConfiguration),
    takeEvery(configActions.updateChatbotFeature.type, _updateChatbotFeature),
    takeEvery(configActions.updateCronConfiguration.type, _updateCronConfiguration),
    takeEvery(configActions.updateFeatureSchema.type, _updateFeatureSchema),
    takeEvery(configActions.updateNotification.type, _updateNotification),
    takeEvery(configActions.updateServicesConfiguration.type, _updateServicesConfiguration),
    takeEvery(configActions.updateTemplate.type, _updateTemplate),
    takeEvery(configActions.upsertChatbotNode.type, _upsertChatbotNode)
];
